import {environment} from '../../util/Environment'
import {apiSlice} from '../store/Api'
import {IOrganizationDto} from './Organization.model'

export const organizationApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getOrganizationById: builder.mutation<IOrganizationDto, string>({
        query(id) {
          return {
            url: `${environment.apiUrl.security}/organization/${id}`,
            method: 'GET',
          }
        },
      }),
    }
  },
})

export const {useGetOrganizationByIdMutation} = organizationApi
